import styled from '@emotion/styled'

import { HeroBreadcrumb } from '@/blocks/Breadcrumb/HeroBreadcrumb'
import { Container } from '@/components/Container'
import { Media } from '@/components/Media'
import { BodyP, HeadingL } from '@/components/Typography'
import { getFormattedDates } from '@/core/utils/dom/getFormattedDate'
import { useBuilderState } from '@/hooks/useBuilderState'
import { useIsMobile } from '@/hooks/useIsMobile'
import { CONFIG } from '@/styles/emotion.config'

const BlogHeroBlockStyles = styled(Container)`
  width: 100%;

  .hero__title {
    grid-area: title;
  }

  .hero__date {
    display: inline-block;
    margin-right: 1rem;
  }

  .hero__media {
    position: relative;
    grid-area: image;
    width: 100%;
    overflow: hidden;
  }

  .hero__media img {
    object-fit: cover;
  }
  .date-article {
    margin-right: 1rem;
  }

  ${CONFIG.media.mobileLg} {
    .hero__content {
      align-items: flex-start;
      justify-content: center;
      margin: 0 auto;
    }

    .hero__media {
      height: 17.5rem;
      display: flex;
      justify-content: center;
    }
  }
`

interface Props {
  title?: string
  category?: string
  product?: string
  image: string
  alt: string
}

const BlogHeroBlock = ({ title, image, alt }: Props) => {
  const isMobile = useIsMobile()
  const { lastUpdated, category } = useBuilderState()
  const formattedDate = lastUpdated && getFormattedDates(lastUpdated)

  return (
    <BlogHeroBlockStyles className="hero" contentClassName="hero__content" spaceIn="m">
      <div className="eu-sm-3-r hero__title">
        {category && <HeroBreadcrumb />}
        {title && (
          <HeadingL dark="high" className="eu-sm-1" tag="h1">
            {title}
          </HeadingL>
        )}
        <BodyP color="dark-medium">
          <span className="date-article" aria-label={`publicado em ${formattedDate?.accessible}`}>
            {formattedDate.visually}
          </span>
          <span>Time Serasa</span>
        </BodyP>
      </div>

      <div className="hero__media">
        <Media
          width={984}
          height={280}
          image={{
            url: image,
            alt: alt?.trim(),
          }}
          type="image"
          layout={isMobile ? 'fixed' : 'responsive'}
          priority
        />
      </div>
    </BlogHeroBlockStyles>
  )
}

export default BlogHeroBlock
